import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { MilestoneNodeCreateRequest, MilestoneNodePagedResultVO, MilestoneNodeUpdateRequest, MilestoneNodeVO } from '../types';

export const milestoneNodeApi = {
  /** 分页查询，不传 pageSize 时默认取全部（pageSize=9999） */
  getList: async (params?: {
    phase?: string;
    name?: string;
    type?: string;
    pageNum?: number;
    pageSize?: number;
  }): Promise<MilestoneNodePagedResultVO> => {
    const queryParams = new URLSearchParams();
    if (params?.phase) queryParams.append('Phase', params.phase);
    if (params?.name) queryParams.append('Name', params.name);
    if (params?.type) queryParams.append('Type', params.type);
    queryParams.append('PageNum', String(params?.pageNum ?? 1));
    queryParams.append('PageSize', String(params?.pageSize ?? 9999));

    const response = await fetch(`${API_ENDPOINTS.MILESTONE_NODES.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<MilestoneNodePagedResultVO>(response);
  },

  getById: async (id: number): Promise<MilestoneNodeVO> => {
    const response = await fetch(API_ENDPOINTS.MILESTONE_NODES.DETAIL(id), {
      headers: getAuthHeaders(),
    });
    return handleResponse<MilestoneNodeVO>(response);
  },

  /** 创建节点，请求体使用 camelCase 匹配后端 */
  create: async (data: MilestoneNodeCreateRequest): Promise<MilestoneNodeVO> => {
    const response = await fetch(API_ENDPOINTS.MILESTONE_NODES.CREATE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<MilestoneNodeVO>(response);
  },

  /** 更新节点，请求体使用 camelCase */
  update: async (id: number, data: MilestoneNodeUpdateRequest): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.MILESTONE_NODES.UPDATE(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<boolean>(response);
  },

  delete: async (id: number): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.MILESTONE_NODES.DELETE(id), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return handleResponse<boolean>(response);
  },
};
